/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * Import scrollTrigger.js bundle
 */
import { setAddTrigger } from "./scrollTrigger/scrollTrigger-addTrigger";
import { ScrollAnimation } from "./scrollTrigger/scrollTrigger-scroll";
import { setparallaxImg } from './scrollTrigger/scrollTrigger-parallax';

/**
 * scrollTrigger
 */
const setScrollTrigger = () => {
  if (window.document.body.classList.contains("home")) {
    var $myWindow = "visited";
    if (window.name.indexOf($myWindow) != -1) {
      document.getElementById('scroll-area').remove();
      document.getElementById('conMv').remove();
      document.getElementById('visitedMv').classList.remove('hidden');
    } else {
      ScrollAnimation();
      document.getElementById('visitedMv').remove();
      window.name = $myWindow;
    }
  } else {
    ScrollAnimation();
  }
  setAddTrigger();
  setparallaxImg();
};

/**
 * Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setScrollTrigger };
